/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IObrienProductVideoViewProps } from './obrien-product-video';
// @ts-ignore
import ReactPlayer from "react-player/vimeo";

export default (props: IObrienProductVideoViewProps) => {

    const { photo, videoUrl  } = props;
    return (
        <section className="product-video">

    

            {photo && videoUrl ? (
            <div className="inside-xl flex-md-new">
                <div className="padding-10 video-test">
                    <div className="obrien-vimeo">
                    <ReactPlayer
                        url={videoUrl}
                        //@ts-ignore
                        controls="true"
                        className="product-player"
                        width="100%"
                        height="100%"
                    />
                    </div>
                </div>
                <div className="padding-10">{photo}</div>
            </div>
            ) : null}

            {videoUrl && !photo ? (
            <div className="inside-xl">
                <div className="padding-10">
                    <div className="obrien-vimeo">
                    <ReactPlayer
                        url={videoUrl}
                        //@ts-ignore
                        controls="true"
                        className="product-player"
                        width="100%"
                        height="100%"
                    />
                    </div>
                </div>
            </div>
            ) : null}

           
            
        </section>
    );
};
